import { Router, Location } from '@remix-run/router';
import { createContext } from 'react';

export interface RouterContextProps {
  router?: Router;
  addBlockerCallback?: (callback: (location: Location) => void) => void;
  removeBlockerCallback?: (callback: (location: Location) => void) => void;
}

const RouterContext = createContext<RouterContextProps>({});

export default RouterContext;
